import React from 'react';
import { Text, View, ASButton, Avatar } from 'core';
import { theme, style, GROUP_ROLES } from 'constants';
import { IcoAccount, IcoPM, IcoClose } from 'icons';
import * as actions from 'actions';
import { lang } from 'lang';

const ConvMember = ({ member, group_id, style, is_admin, user_id, options }) => {
  let default_options = [{ icon: IcoPM, text: lang.CREATE_PM_CONV, onPress: () => actions.selectSendPM(member) }];
  const mk_admin = { icon: IcoAccount, text: lang.MAKE_ADMIN, onPress: () => actions.sendMakeAdmin({ member_id: member.id, conv_id: group_id }) };
  const un_admin = { icon: IcoAccount, text: lang.UNMAKE_ADMIN, onPress: () => actions.sendUnmakeAdmin({ member_id: member.id, conv_id: group_id }) };
  const remove_member = { icon: IcoClose, text: lang.REMOVE_MEMBER, onPress: () => actions.clickRemoveMember(member.id) };
  default_options = is_admin ? [...default_options, member.role === GROUP_ROLES.ADMIN ? un_admin : mk_admin, remove_member] : default_options;

  options = options || default_options;
  return (
    <View style={[styles.member]}>
      <Avatar data={member} size={32} />
      <Text style={styles.name}>{member.name}</Text>
      {member.role === GROUP_ROLES.ADMIN ? <Text style={styles.tagText}>({lang.GROUP_ROLES[member.role]})</Text> : null}
      <Text style={{ flex: 1 }} />
      {member.id !== user_id && <ASButton options={options} />}
    </View>
  );
};

const styles = style({
  member: {
    marginVertical: 2,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    height: 60
  },
  name: {
    color: theme.gray_color,
    fontSize: theme.font_md,
    margin: 10
  },
  tagText: {
    color: '#888',
    fontSize: theme.font_sm
  }
});

export default ConvMember;



// WEBPACK FOOTER //
// ./src/components/right/conv_member.js